///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { AppConfigService } from '../app/core/app-config.service';

export const environmentBase = {
    appId: 'f41a47f9-663c-4894-9d85-623a8a83a17f',
    appName: 'OtvoreniGrad2',
    getDataProviders() {
        return AppConfigService.settings.dataProviders;
    },
    getAuthentication() {
        return AppConfigService.settings.authentication;
    },
};



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/environments/environment-base.ts